module.exports = __webpack_public_path__ + "img/icon_close_3.3783977b.png";